import React from 'react'

export default function Contact() {
    return (
        <div>
            <h2>Contact</h2>
        </div>
    )
}
